<template>
    <div class="container text-left">
      <div class="row">
        <div class="col-12">
          <h2>안틱가구/빈티지/장식품</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>
            지방 픽업 및 포장 – 부산 또는 인천항 까지 선적 가능, 당사의 특장점은 컨테이너 단위의 물량이 채워지지 않더라도 경쟁력 있는 운임으로 CONSOLE 선적이 주기적으로 가능 합니다. CNTR 1 대를 채워야 운임이 저렴하다는 말은 옛날 얘기입니다. 유코쉬핑에서는 업계 최고의 컨테이너 콘솔 화물 점유율로 경쟁력 있는 물류비용을 제공해 드립니다.

          </p>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "Furniture"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Furniture.vue